module.exports = __webpack_public_path__ + "img/40_45.763f9e0e.png";